import { createSetCookieString, SetCookieValue, SetCookieOptions } from './createSetCookieString';

export function safelySetDsCookie(cookieName: string, value: SetCookieValue, options: SetCookieOptions = {}): void {
    const defaultCookiesOptions: SetCookieOptions = {
        path: '/',
        secure: true,
    };

    document.cookie = createSetCookieString(cookieName, value, { ...defaultCookiesOptions, ...options });
}
